import { LOCALES } from 'src/interfaces/i18n.types';

const krLocale: Partial<ILocale> = {
  name: LOCALES.KR,
};

export { krLocale };
